import { CONTENT_RENDERER_METRIC } from '@confluence/view-content-perf-metrics/entry-points/pageSegmentLoadMetrics';
import {
	BYLINE_METRIC,
	CONTENT_TITLE_METRIC,
} from '@confluence/content-header/entry-points/pageSegmentLoadMetrics';
import type { PageSegmentLoad } from '@confluence/browser-metrics/entry-points/pageSegmentLoadType';
import { useEmbeddedViewPageFeatures } from '@confluence/embedded-confluence-allowed-features/entry-points/view-page';
import {
	EMBEDDED_VIEW_PAGE_LOAD_KEY,
	CONTENT_TITLE_SEGMENT_KEY,
	BYLINE_SEGMENT_KEY,
} from '@confluence/browser-metrics/entry-points/metric-keys';
import type { CustomViewPageLoadConfig } from '@confluence/view-page-common';

const defaultPageLoadSegments = [CONTENT_TITLE_METRIC, CONTENT_RENDERER_METRIC];
const defaultFmpUntilStopMetrics: PageSegmentLoad[] = [CONTENT_TITLE_SEGMENT_KEY];

export const useTrackingConfig = (): CustomViewPageLoadConfig => {
	const { hasByLineContributors, hasByLineExtensions } = useEmbeddedViewPageFeatures();

	const shouldIncludeByline = hasByLineContributors || hasByLineExtensions;
	const expectedPageLoadSegments = shouldIncludeByline
		? [...defaultPageLoadSegments, BYLINE_METRIC]
		: defaultPageLoadSegments;
	const fmpUntilStopTimeMetrics: PageSegmentLoad[] = shouldIncludeByline
		? [BYLINE_SEGMENT_KEY, ...defaultFmpUntilStopMetrics]
		: defaultFmpUntilStopMetrics;

	return {
		pageLoadKey: EMBEDDED_VIEW_PAGE_LOAD_KEY,
		expectedPageLoadSegments,
		fmpUntilStopTimeMetrics,
	};
};
